export const INIT = 'INIT';
export const SEARCH = 'SEARCH';
export const SEARCH_RESULT = 'SEARCH_RESULT';
